import { Navigate } from 'react-router';

import { getToken } from '@src/helpers/axios.helpers';

interface IProtectedRouteProps {
  type: 'guest' | 'authorized';
  redirectPath: string;
  children: React.ReactNode;
}

export const ProtectedRoute = ({
  type,
  redirectPath,
  children,
}: IProtectedRouteProps) => {
  const token = getToken();

  const isAllowed = type === 'authorized' ? !!token : !token;

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
